export * from './ads';
export * from './analytics';
export * from './applications';
export * from './mfeEventBus';
export * from './pii';
export const AnalyticsFlaggedDataPoint = {
  transactionStartView: 'transactionStartView',
};

export enum AnalyticsConst {
  NOT_SET = '(not set)',
  SUBMIT = 'submit',
  API = 'api',
}

export enum GoogleAnalyticsLimit {
  MAX_EVENT_NAME_LENGTH = 40,
  MAX_EVENT_PARAMETER_LENGTH = 100,
}
